import React, { useState, useEffect } from 'react';
import { RefreshCw, AlertTriangle, Edit3, RotateCcw } from 'lucide-react';
import { syncService } from '../services/api';
import ProductEditor from './ProductEditor';

const ErrorsList = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    fetchFailedProducts();
  }, []);

  const fetchFailedProducts = async () => {
    try {
      setLoading(true);
      const response = await syncService.getStagedProducts('FAILED');
      setProducts(response.data.products || []);
    } catch (error) {
      console.error('Failed to fetch products:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = async (id) => {
    try {
      await syncService.updateStagedProduct(id, { stagingStatus: 'READY' });
      fetchFailedProducts();
    } catch (error) {
      console.error('Retry failed:', error);
    }
  };

  const handleProductSaved = () => {
    setSelectedProduct(null);
    fetchFailedProducts();
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1>Publishing Errors</h1>
          <p className="text-secondary" style={{ marginTop: '4px' }}>Products rejected by Leroy Merlin</p>
        </div>
        <div className="page-header-actions">
          <button className="btn btn-secondary" onClick={fetchFailedProducts}>
            <RefreshCw size={16} /> Refresh
          </button>
        </div>
      </div>
      <div className="card">
        {loading ? (
          <div className="loading">
            <div className="spinner"></div>
          </div>
        ) : products.length === 0 ? (
          <div className="empty-state">
            <AlertTriangle size={48} />
            <h3>No errors</h3>
            <p>All products have been successfully published or are pending</p>
          </div>
        ) : (
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>Product</th>
                  <th>SKU</th>
                  <th>Error</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {products.map((product) => {
                  return (
                    <tr key={product.id}>
                      <td>{product.marketplaceTitle || product.wooName}</td>
                      <td>{product.marketplaceSku || '-'}</td>
                      <td style={{ color: '#d70015' }}>{product.publishError || 'Unknown error'}</td>
                      <td>
                        <button className="btn btn-ghost btn-sm" onClick={() => setSelectedProduct(product)}>
                          <Edit3 size={16} />
                        </button>
                        <button className="btn btn-ghost btn-sm" onClick={() => handleRetry(product.id)}>
                          <RotateCcw size={16} />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {selectedProduct && (
        <ProductEditor
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
          onSave={handleProductSaved}
        />
      )}
    </div>
  );
};

export default ErrorsList;